import { createBrowserClient } from '@supabase/ssr';

export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      cookies: {
        getAll() {
          if (typeof document === 'undefined') return [];
          try {
            return document.cookie.split(';').filter(c => c.trim()).map((cookie) => {
              const eqIndex = cookie.trim().indexOf('=');
              const name = eqIndex !== -1 ? cookie.trim().substring(0, eqIndex) : cookie.trim();
              const rest = eqIndex !== -1 ? cookie.trim().substring(eqIndex + 1) : '';
              return { name, value: decodeURIComponent(rest) };
            });
          } catch {
            return [];
          }
        },
        setAll(cookiesToSet: Array<{ name: string; value: string; options?: any }>) {
          if (typeof document === 'undefined') return;
          try {
            cookiesToSet.forEach(({ name, value, options }) => {
              let cookieString = `${name}=${encodeURIComponent(value)}; Path=${
                options?.path || '/'
              }`;

              if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
                cookieString += '; Secure; SameSite=Lax';
              } else {
                cookieString += '; SameSite=Lax';
              }

              if (options?.maxAge) {
                cookieString += `; max-age=${options.maxAge}`;
              }
              if (options?.domain) {
                cookieString += `; domain=${options.domain}`;
              }
              if (options?.expires) {
                cookieString += `; expires=${options.expires}`;
              }
              document.cookie = cookieString;
            });
          } catch {
            // Silently handle cookie setting errors
          }
        },
      },
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
      },
    }
  );
}